import React, { useState } from 'react';
import OIcon from '../components/OIcon';
import XIcon from '../components/XIcon';
import { Link } from 'react-router-dom';

function ChooseSide() {
    const [side, setSide] = useState<'x' | 'o'>('x');

    return (
        <div className="flex h-screen flex-col items-center justify-center">
            <header>
                <h1 className="text-xl font-bold">Choose your side</h1>
            </header>
            <div className="mt-12 flex">
                <div className="flex flex-col items-center justify-center ">
                    <XIcon className="h-24 w-24"></XIcon>
                    <input
                        name="side"
                        type="radio"
                        className="mt-16 h-6 w-6"
                        value="x"
                        onChange={(e) => setSide('x')}
                        checked={side === 'x'}
                    />
                </div>
                <div className="ml-16 flex flex-col items-center justify-center">
                    <OIcon className="h-24 w-24"></OIcon>
                    <input
                        name="side"
                        type="radio"
                        className="mt-16 h-6 w-6"
                        value="o"
                        onChange={(e) => setSide('o')}
                        checked={side === 'o'}
                    />
                </div>
            </div>

            <Link
                to={`/play/${side}`}
                className="mt-24 rounded-full bg-blue-500 py-2 px-6 text-white shadow-lg transition duration-100 hover:bg-blue-400 focus:bg-blue-600"
            >
                Play
            </Link>
        </div>
    );
}

export default ChooseSide;
